import moment from "moment";
import {
  ActivityPlan,
  ActivityPlanItem,
  ActivityPlanItemWithResident,
  ActivityStatus,
  AppStateResidentsActivityPlan,
  ResidentActivityType,
  ResidentPresenceItem,
} from ".";
import { presenceStatuses } from "../residents";
import { ResidentActionTypes, RESIDENTS } from "../residents/types";
import { weirdData } from "./";
import {
  DAILY_PLAN,
  IGetResidentsActivitiesSuccess,
  IGetResidentsConfigurationSuccess,
  IGetResidentsPresencesSuccess,
  PlanActionType,
} from "./types";
const initialState: AppStateResidentsActivityPlan = {
  activities: {},
  presences: {},
  configurations: {},
  // selectedDate: undefined,
  isLoadingConfig: undefined,
  isLoadingActivities: undefined,
  isLoadingPresences: undefined,
  daysInfo: {},
  feedbackOptions: undefined,
  skipOptions: undefined,
};
const roundedDown = (date: string) => {
  return Math.floor(moment(date).minute() / 7.5) * 7.5;
};

const oneDataRound = (date: string): string => {
  return weirdData(
    moment(date).minute(roundedDown(date)).second(0).millisecond(0)
  ).replace(".000", "");
};
const roundRep = (activities: ActivityPlanItem[]): ActivityPlanItem[] => {
  const res = activities.map((el) => {
    if (el?.status !== ActivityStatus.REPORTED) return el;
    else
      return {
        ...el,
        date: oneDataRound(el.date),
      };
  });
  return res;
};

const reducer = (
  state = initialState,
  action: ResidentActionTypes | PlanActionType
): AppStateResidentsActivityPlan => {
  switch (action.type) {
    case DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_SUCCESS: {
      const { data, startDate } = (action as IGetResidentsActivitiesSuccess)
        .payload;
      // let maped = {};
      let mappedActivities = {};
      // const local = moment.utc(moment().startOf('day')).local();
      // const yesterday = moment(local).subtract(1, 'days');
      const activities = preprocessActivities(data);
      const wasDays = state.daysInfo || {};
      if (Array.isArray(data) && data.length > 0) {
        Object.keys(activities).map((residentId: string) => {
          const wasActivities = state?.activities
            ? state?.activities[residentId] || []
            : [];

          const dontNeedUpdate =
            wasDays[residentId] !== undefined &&
            wasDays[residentId][startDate] !== undefined;
          mappedActivities = {
            ...mappedActivities,
            [residentId]: dontNeedUpdate
              ? roundRep(wasActivities)
              : roundRep([...wasActivities].concat(activities[residentId])),
          };
          wasDays[residentId] = { [startDate]: true };
          return null;
        });
        return {
          ...state,
          // configurations: maped,
          isLoadingActivities: false,
          daysInfo: { ...state.daysInfo, ...wasDays },
          activities: { ...mappedActivities },
        };
      }
      return { ...state, isLoadingActivities: false };
    }
    case DAILY_PLAN.GET_RESIDENTS_PRESENCES_SUCCESS: {
      const { data, startDate } = (action as IGetResidentsPresencesSuccess)
        .payload;
      let mappedPresences = {};
      const presences = preprocessPresences(data);
      if (Array.isArray(data) && data.length > 0) {
        Object.keys(presences).map((residentId: string) => {
          mappedPresences = {
            ...mappedPresences,
            [residentId + startDate]: presences[residentId],
          };
          return null;
        });
        return {
          ...state,
          // configurations: maped,
          isLoadingPresences: false,
          presences: { ...mappedPresences },
        };
      }
      return { ...state, isLoadingPresences: false };
    }
    case DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_SUCCESS: {
      const { data, startDate } = action.payload;
      const presences = preprocessPresences(data);
      let mappedPresences = { ...state.presences };
      Object.keys(presences).map((residentId: string) => {
        mappedPresences = {
          ...mappedPresences,
          [residentId + startDate]: presences[residentId],
        };
        return null;
      });
      return {
        ...state,
        presences: mappedPresences,
        // daysInfo: { ...state.daysInfo, [residentId]: { ...wasDays, [startDate]: true } },
        isLoadingPresences: false,
      };
    }
    case DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_SUCCESS: {
      const data = (action as IGetResidentsConfigurationSuccess).payload;
      let maped = {};
      const activities = data;
      if (Array.isArray(activities) && activities.length > 0) {
        activities.map((el: any) => {
          const { residentId } = el;
          const wasConfig = maped[residentId] || {};
          wasConfig[el.type] = el;
          maped = { ...maped, [residentId]: wasConfig };
          return null;
        });
        return {
          ...state,
          configurations: maped,
          isLoadingConfig: false,
        };
      }
      return { ...state, isLoadingConfig: false };
    }
    case DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_SUCCESS: {
      const { data, residentId, startDate } = action.payload;
      const wasActivities = state.activities[residentId] || [];
      const wasDays = state.daysInfo[residentId] || {};
      if (wasDays && wasDays[startDate])
        return { ...state, isLoadingActivities: false };
      const res = wasActivities.length ? [] : data;

      if (wasActivities.length)
        data.map((el) => {
          if (
            wasActivities.findIndex(
              (act) => act.type === el.type && act.date === el.date
            ) === -1
          ) {
            if (el?.status !== ActivityStatus.REPORTED) res.push(el);
            else
              res.push({
                ...el,
                date: oneDataRound(el.date),
              });
          }
          return null;
        });

      return {
        ...state,
        activities: {
          ...state.activities,
          [residentId]: wasActivities.concat(res),
        },
        daysInfo: {
          ...state.daysInfo,
          [residentId]: { ...wasDays, [startDate]: true },
        },
        isLoadingActivities: false,
      };
    }

    case DAILY_PLAN.GET_ACTIVITY_BY_SOCKET: {
      const data = action.payload;
      const wasPlans = state.activities[data?.residentId] || [];
      if (data.activityStatus === ActivityStatus.REPORTED) {
        wasPlans.push({
          type: data.activityType,
          status: ActivityStatus.REPORTED,
          activityParams: data.activityParams,
          date: oneDataRound(data.activityTime),
        } as ActivityPlanItem);

        return {
          ...state,
          activities: {
            ...state.activities,
            [data?.residentId]: [...wasPlans],
          },
        };
      }
      const oldItemInd = wasPlans.findIndex(
        (el) => el.type === data.activityType && el.date === data.activityTime
      );
      if (oldItemInd !== -1) {
        wasPlans.splice(oldItemInd, 1, {
          ...wasPlans[oldItemInd],
          status:
            data.activityStatus.toLowerCase() === "unskip"
              ? ActivityStatus.CREATED
              : data.activityStatus,
        });
        return {
          ...state,
          activities: {
            ...state.activities,
            [data?.residentId]: [...wasPlans],
          },
        };
      }
      return state;
    }

    case DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_SUCCESS: {
      const data = action.payload;
      return { ...state, feedbackOptions: data };
    }
    case DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_FAILURE: {
      const fecesRadios = {
        "Normal stool": false,
        Diarrhea: false,
      };

      const fecesSelected = Object.values(fecesRadios).some(
        (val) => val === true
      );

      return {
        ...state,
        feedbackOptions: {
          [ResidentActivityType.TOILET]: {
            radioButtons: {
              "No outputs": false,
              Outputs: {
                checkBoxes: {
                  Urine: false,
                  Feces: {
                    selected: fecesSelected,
                    radioButtons: fecesRadios,
                  },
                },
              },
              Refused: false,
            },
          },
        },
      };
    }

    case DAILY_PLAN.GET_ACTIVITIES_SKIP_OPTIONS_SUCCESS: {
      const data = action.payload;
      return { ...state, skipOptions: data };
    }
    case DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_REQUEST:
    case DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_REQUEST: {
      return { ...state, isLoadingActivities: true, isLoadingPresences: true };
    }
    case DAILY_PLAN.GET_RESIDENTS_PRESENCES_REQUEST:
    case DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_REQUEST: {
      return { ...state, isLoadingPresences: true };
    }
    case DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_REQUEST: {
      return { ...state, isLoadingConfig: true };
    }
    case DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_FAILURE:
    case DAILY_PLAN.GET_ONE_RESIDENT_ACTIVITIES_FAILURE: {
      return { ...state, isLoadingActivities: false };
    }
    case DAILY_PLAN.GET_RESIDENTS_PRESENCES_FAILURE:
    case DAILY_PLAN.GET_ONE_RESIDENT_PRESENCES_FAILURE: {
      return { ...state, isLoadingPresences: false };
    }
    case DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_FAILURE: {
      return { ...state, isLoadingConfig: false };
    }
    case RESIDENTS.CHANGE_NODE_PRESENCE_BY_SOCKET: {
      const { residentIds } = action.payload;
      // const resId = StorageHelper.instance.GetResident();
      // if (residentIds.indexOf(resId) !== -1) {
      const resDays = { ...state.daysInfo };
      const resActivities = { ...state.activities };
      residentIds.map((res) => delete resDays[res]);
      residentIds.map((res) => {
        delete resActivities[res];
        return null;
      });
      return { ...state, daysInfo: resDays, activities: resActivities };
    }
    default:
      return state;
  }
};

const preprocessActivities = (
  activities: ActivityPlanItemWithResident[]
): ActivityPlan => {
  const plan = {};
  activities.map((el) => {
    if (plan[el?.residentId]) {
      plan[el?.residentId] = plan[el?.residentId].concat(el);
    } else plan[el?.residentId] = [el];
    return null;
  });
  return plan;
};

const preprocessPresences = (presences: ResidentPresenceItem[]): any => {
  const plan = {};
  presences.map((el) => {
    if (el?.type !== presenceStatuses.away) return null;
    if (plan[el?.residentId]) {
      plan[el?.residentId] = plan[el?.residentId].concat(el);
    } else plan[el?.residentId] = [el];
    return null;
  });
  return plan;
};

export default reducer;
